var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudCheckDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 11.336H4.43816C2.7235 11.3333 1.3335 9.99534 1.3335 8.34467C1.3335 6.69467 2.7235 5.35667 4.43816 5.35667C4.70016 4.182 5.63416 3.22334 6.88816 2.84134C8.1415 2.46 9.5255 2.71267 10.5175 3.508C11.5095 4.30134 11.9588 5.51267 11.6975 6.68734H12.3575C13.2775 6.68734 14.0708 7.228 14.4428 8.01134",
    stroke: "#303234",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4001,
    cy: 11.6,
    r: 2.8,
    fill: "#59D875"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4959 11.5656L11.8904 11.96L13.03 10.8203C13.1801 10.6703 13.4268 10.6823 13.5616 10.8461C13.6791 10.989 13.669 11.1977 13.5382 11.3285L12.1824 12.6843C12.0232 12.8435 11.7634 12.8378 11.6113 12.6719L11.0173 12.0239C10.8974 11.8931 10.9018 11.6911 11.0272 11.5656C11.1567 11.4362 11.3665 11.4362 11.4959 11.5656Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCheckDark);
export default __webpack_public_path__ + "static/media/cloud-check-dark.9d6a07514be88e8c36eddd9bb2fe4377.svg";
export { ForwardRef as ReactComponent };